import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { CSSProperties, ReactNode, useMemo, useState } from "react";
import { Media } from "reactstrap";
import { COLOR_DANGER } from "../../constants/theme";

interface Props {
  id?: string;
  label?: string;
  className?: string;
  image?: string;
  active?: boolean;
  icon?: ReactNode;
  style?: CSSProperties;
  height?: string;
  width?: string;
  backgroundColor?: string;
  color?: string;
  labelFontSize?: number;
  onClick?: () => void;
}

export default function Avatar(props: Props) {
  const {
    id,
    label,
    className,
    image,
    active = true,
    icon,
    backgroundColor = "#f8f9fa",
    color = "#000",
    height = "40px",
    width = "40px",
    style,
    labelFontSize,
    onClick,
  } = props;

  const [imgError, setImgError] = useState(false);

  const normalized = useMemo(() => {
    const normalize = (v?: string) => {
      if (!v) return v;
      const trimmed = String(v).trim();
      if (/^\d+$/.test(trimmed)) return `${trimmed}px`;
      return trimmed;
    };
    return {
      width: normalize(width),
      height: normalize(height),
      image:
        image && !["null", "undefined", ""].includes(String(image).trim())
          ? String(image).trim()
          : undefined,
    };
  }, [width, height, image]);

  return (
    <div
      id={id}
      style={{
        width: normalized.width,
        height: normalized.height,
        minHeight: normalized.height,
        minWidth: normalized.width,
        boxSizing: "border-box",
        overflow: "hidden",
        backgroundColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
      }}
      className={`${className} d-flex rounded-circle position-relative`}
      onClick={onClick}
    >
      {!active && (
        <FontAwesomeIcon
          icon={["fas", "ban"]}
          size="1x"
          className="position-absolute"
          color={COLOR_DANGER}
        />
      )}
      {normalized.image && !imgError ? (
        <Media
          style={{
            width: normalized.width,
            height: normalized.height,
            display: "block",
            flexShrink: 0,
            objectFit: "cover",
            borderRadius: "50%",
          }}
          object
          src={normalized.image}
          alt="Generic placeholder image"
          onError={() => setImgError(true)}
        />
      ) : label ? (
        <span className="m-auto text-primary " style={{ color, fontSize: labelFontSize }}>
          {label?.toUpperCase()}
        </span>
      ) : (
        <span className="m-auto" style={{ color }}>
          {icon}
        </span>
      )}
    </div>
  );
}
